import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

const SceneSummaries = ({ scenes, onUpdate, onReorder, onDelete, suggestions, setSuggestions }) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDismissSuggestion = (sceneId, idx) => {
    const updatedSuggestions = suggestions[sceneId].filter((_, i) => i !== idx);
    setSuggestions((prev) => ({
      ...prev,
      scenes: { ...prev.scenes, [sceneId]: updatedSuggestions },
    }));
  };


  return (
    <div className="scenes-container">
      {scenes.map((scene, index) => (
        <div
          key={scene.id}
          className="scene-card mb-3"
          draggable
          onDragStart={() => setDraggedIndex(index)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => {
            if (draggedIndex !== null) {
              onReorder(draggedIndex, index);
              setDraggedIndex(null);
            }
          }}
        >
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-light d-flex justify-content-between align-items-center">
              <h5>Scene {index + 1}</h5>
              <button className="btn btn-outline-danger btn-sm" onClick={() => onDelete(index)}>
                Delete
              </button>
            </div>
            <div className="card-body">
              <textarea
                className="form-control border-0"
                value={scene.content}
                onChange={(e) => onUpdate(index, e.target.value)}
                rows={3}
              />
{suggestions[scene.id] && suggestions[scene.id].length > 0 && (
  <div className="mt-3 bg-light p-3 rounded">
    <h6>Suggestions for Scene {index + 1}</h6>
    <ul>
      {suggestions[scene.id].map((suggestion, idx) => (
        <li key={idx}>
          <p>{suggestion.content}</p>
          <button
            className="btn btn-outline-success btn-sm me-2"
            onClick={() => onUpdate(index, `${scene.content}\n${suggestion.content}`)}
          >
            Implement
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => handleDismissSuggestion(scene.id, idx)}
          >
            Dismiss
          </button>
        </li>
      ))}
    </ul>
  </div>
)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SceneSummaries;
